import React from 'react';
import Formulario from "./components/Formulario";
import Lista from "./components/Lista";

const Clientes = props => {
    const path = props.match.path;
    return (
        <React.Fragment>
            {(path === '/cliente/new' || path.indexOf('/cliente/edit') === 0) && <Formulario {...props}/>}
            {path === '/cliente/list' && <Lista {...props}/>}
        </React.Fragment>
    );
};

export default Clientes;
